import { render, staticRenderFns } from "./ContractorHall.vue?vue&type=template&id=0d9b5a50&scoped=true"
import script from "./ContractorHall.vue?vue&type=script&lang=js"
export * from "./ContractorHall.vue?vue&type=script&lang=js"
import style0 from "./ContractorHall.vue?vue&type=style&index=0&id=0d9b5a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b5a50",
  null
  
)

export default component.exports